import $ from 'jquery';
export default class Nav {
  constructor(target) {
    this.target = target;
    this.body = $('body');
    this.a = this.target.find('a').not('.navi-parent-a');
    this.hum = this.target.find('.nav-hum');
    this._setHum();
    this._setEvent();
    this._setScroll();
  }

  _setHum() {
    this.hum.click(
      function () {
        if (this.target.hasClass('nav--open')) {
          this.target.removeClass('nav--open');
          this.body.removeClass('over-flow--hidden');
        } else {
          this.target.addClass('nav--open');
          this.body.addClass('over-flow--hidden');
        }
      }.bind(this),
    );
  }

  _setEvent() {
    this.a.click(
      function () {
        this.target.removeClass('nav--open');
      }.bind(this),
    );
  }

  _setScroll() {
    var scroll = 0;
    var navi = this.target;
    $(window).on('scroll', function () {
      if ($(this).scrollTop() < scroll) {
        //上スクロールの時の処理
        navi.addClass('nav--fixed');
      } else {
        //下スクロールの時の処理
        navi.removeClass('nav--fixed');
      }
      scroll = $(this).scrollTop();
    });

    // $(window).scroll(
    //   function () {
    //     var elemOffset = this.elem.offset().top;
    //     var scrollPos = $(window).scrollTop();
    //     if (scrollPos > elemOffset) this.target.addClass('header--open');
    //     else this.target.removeClass('header--open');
    //     this.menu.removeClass('header__menu--open');
    //     this.navBtn.removeClass('header__navBtn--close');
    //   }.bind(this),
    // );
  }

  _setSubmenu() {
    this.navSubBtn.click(
      function () {
        this.navSubBtn.toggleClass('header__menu__subBtn--open');
        this.navSubBtn.next().toggleClass('header__menu__subMenu--open');
      }.bind(this),
    );
  }
}

// (() => {
//   const targets = $('.nav');
//   if (!targets.length) return;
//   new Nav(targets);
// })();
